import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { Formik } from "formik";
import { contactFormSchema } from "../../validations/contactForm";
interface valuesInterface {
  name: string;
  message: string;
  email: string;
}
interface actionsInterface {
  setSubmitting: (a: boolean) => void;
  resetForm: (a: object) => void;
}
enum formMessageTypes {
  "SUCCESS" = "SUCCESS",
  "ERROR" = "ERROR",
  "PROMPT" = "PROMPT",
}
const initFormValues: valuesInterface = {
  name: "",
  message: "",
  email: "",
};

const FormTextInputField: React.FC<{
  label: string;
  name: string;
  type: string;
  placeholder: string;
  value: string;
  handleChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  isError: boolean;
  isTextArea?: boolean;
}> = ({
  label,
  name,
  type,
  placeholder,
  value,
  handleChange,
  isError,
  isTextArea,
}) => {
  return (
    <p className="flex flex-col mb-2 text-base">
      <label className="text-primary-500 mb-2">{label}</label>
      {!isTextArea ? (
        <input
          type={type}
          placeholder={placeholder}
          name={name}
          value={value}
          onChange={handleChange}
          className={
            "bg-transparent outline-none rounded-sm border-primary-200/20 border-[1px] border-b-[1px] border-b-solid border-b-primary-500 caret-primary-500 px-4 py-2 text-white w-full" +
            (isError ? " border-b-red-500 focus:border-b-transparent" : "")
          }
        />
      ) : (
        <textarea
          placeholder={placeholder}
          name={name}
          value={value}
          onChange={handleChange}
          style={{ minHeight: "200px" }}
          className={
            "bg-transparent outline-none rounded-sm border-primary-200/20 border-[1px] border-b-[1px] border-b-solid border-b-primary-500 caret-primary-500 px-4 py-2 text-white w-full" +
            (isError ? " border-b-red-500 focus:border-b-transparent" : "")
          }
        />
      )}
    </p>
  );
};
export const ContactContent: React.FC = () => {
  const [formMessage, setFormMessage] = useState({
    type: "",
    content: "",
  });
  // type can be success, error or prompt
  const handleSubmit = (values: valuesInterface, actions: actionsInterface) => {
    const { setSubmitting, resetForm } = actions;

    fetch(
      "https://portfolio-2f44f-default-rtdb.firebaseio.com//messages.json",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      }
    )
      .then((res) => {
        // success api request
        setFormMessage({
          type: formMessageTypes.SUCCESS,
          content: "Message sent successfully, Thank you!!",
        });
        resetForm(initFormValues);
        console.log(resetForm, initFormValues, res);
      })
      .catch((err) => {
        // error api request
        console.log(err);
        setFormMessage({
          type: formMessageTypes.ERROR,
          content: "An error occurred, kindly try again!",
        });
      })
      .finally(() => setSubmitting(false));
  };
  return (
    <div
      className={
        "flex min-h-screen flex-col pt-[5rem] md:pt-[10rem] px-[7.5%]  text-[#f7f7f7] font-nunito"
      }
    >
      <h1 className="text-base md:text-xl tracking-wider font-lato font-bold text-primary-500">
        Contact Me
      </h1>
      <p className="text-base md:text-lg my-4">
        You can contact me via my social handles on the right, also by sending a
        mail to{" "}
        <a href="mailto:devwithsammy@gmail.com" className="text-primary-500">
          devwithsammy@gmail.com
        </a>
        , or by completing the form below.{" "}
      </p>
      <div className="mt-10">
        <Formik
          onSubmit={handleSubmit}
          initialValues={initFormValues}
          validationSchema={contactFormSchema}
        >
          {({
            handleChange,
            touched,
            errors,
            values,
            handleSubmit,
            isSubmitting,
          }) => (
            <form
              onSubmit={handleSubmit}
              className={
                " bg-dark-500 border-[1px] border-slate-100/10 rounded-xl py-8 px-8 text-base max-w-[600px] mx-auto opacit-[0.9] transition-all duration-300 hover:opacity-100"
              }
            >
              <FormTextInputField
                label="Your name*"
                name="name"
                type="text"
                placeholder="Name"
                value={values.name}
                handleChange={handleChange}
                isError={touched.name && errors.name ? true : false}
              />
              <br />
              <FormTextInputField
                label="Your email*"
                name="email"
                type="email"
                placeholder="example@example.com"
                value={values.email}
                handleChange={handleChange}
                isError={touched.email && errors.email ? true : false}
              />
              <br />

              <FormTextInputField
                label="Message*"
                name="message"
                type="text"
                placeholder="Message"
                value={values.message}
                handleChange={handleChange}
                isError={touched.message && errors.message ? true : false}
                isTextArea={true}
              />

              <p className="mt-8"></p>
              {formMessage.type && formMessage.content && (
                <p
                  className={
                    "font-base mb-2" + formMessage.type ===
                    formMessageTypes.ERROR
                      ? "text-red-500"
                      : formMessage.type === formMessageTypes.SUCCESS
                      ? "text-green-500"
                      : "text-inherit"
                  }
                >
                  {formMessage.content}
                </p>
              )}
              <button
                type="submit"
                disabled={isSubmitting}
                className={
                  "flex gap-2 border-[2px] border-primary-500 py-2 px-8 rounded-md text-primary-500 font-nunito lowercase items-center "
                }
              >
                {!isSubmitting ? (
                  <>
                    <span>Send Message</span>
                    <Icon icon="entypo:mail" />
                  </>
                ) : (
                  <>
                    <span>Sending</span>
                    <Icon icon="eos-icons:loading" />
                  </>
                )}
              </button>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};
